import styled from 'styled-components'

import media from '../../../../../styles/media'

export const Title = styled.h2`
  font-size: 1.8rem;
  color: #007bff;
  line-height: 1.1;
  margin-bottom: 1rem;
`

export const Detail = styled.p`
  margin-top: 0;
  margin-bottom: 1rem;
  color: #7a7878;
  font-size: 1rem;
`
export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 10px 0;
  padding: 0 16px;
  flex-direction: column;

  ${media.md`
    display: flex;
    flex-direction: row;
    margin: 24px 0;
  `}
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`
export const Img = styled.img`
  max-width: 70px;
  margin-right: 1.5rem;
  margin-top: 23px;
`
